module.exports = __webpack_public_path__ + "kangping/img/3.31952899.png";